export default "__VITE_ASSET__jExZGLgm__"